module.exports = __webpack_public_path__ + "static/emanagement3-74317759fdbe348e81f90a62a08fd711.png";